<template>
  <v-container grid-list-xs ma-0 pa-0 fluid>
    <slot :args="args" :data="items" :loading="loading">
      {{data}}
    </slot>
  </v-container>
</template>

<style scoped>

</style>

<script>
  import GhInvoke from "./ghInvoke.ts";
  export default GhInvoke;
</script>